<script setup lang="ts">
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import { getFilteredNavigation } from '@/navigation';
import TileNavigationItem from './components/TileNavigationItem.vue';
import { settingsNavigationRaw } from '@/navigation/menus/settingsNavigationRaw';
import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const navigation = getFilteredNavigation(useRouter(), useRoute(), settingsNavigationRaw);

const sharedHeight = ref(0);
// tile render handler
const tileRenderedHandler = (tileHeight: number) => {
  if (sharedHeight.value < tileHeight) {
    sharedHeight.value = tileHeight;
  }
};
</script>

<template>
  <BasePage>
    <div
      v-for="navigationEntry in navigation.entries"
      :key="navigationEntry.titleI18n"
      class="column"
    >
      <TileNavigationItem
        v-for="subNavigationEntry in navigationEntry.subNavigation?.entries"
        :key="subNavigationEntry.titleI18n"
        :onRendered="tileRenderedHandler"
        :item="subNavigationEntry"
        :minHeight="sharedHeight"
      />
    </div>
  </BasePage>
</template>

<style lang="scss" scoped>
.column {
  display: flex;
  flex-wrap: wrap;
  margin-left: -24px;
  margin-top: -32px;
  margin-bottom: 32px;
}

.column:last-child {
  margin-bottom: 0;
}
</style>
